import {
  SET_FOLDER_MODAL_ID,
  SET_FOLDER_MODAL_IS_VISIBLE
} from './types'

export const state = {
  isVisible: false
}

export const mutations = {
  [SET_FOLDER_MODAL_ID] (state, value) {
    state.id = value
  },
  [SET_FOLDER_MODAL_IS_VISIBLE] (state, value) {
    state.isVisible = value
  }
}

export const actions = {
  openFolderModal ({ commit, dispatch }) {
    dispatch('prepareFolderModal')
  },
  openFolderModalFolder ({ commit, dispatch }, folderId) {
    return dispatch('prepareFolderModal')
      .then(() => dispatch('folderForm/show', { folderId }, { root: true }))
  },
  closeFolderModal ({ commit }) {
    commit(SET_FOLDER_MODAL_IS_VISIBLE, false)
  },
  prepareFolderModal ({ commit, dispatch }) {
    dispatch('folderForm/reset')
    commit(SET_FOLDER_MODAL_IS_VISIBLE, true)
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/folders/folderModal.js